import CreditConditions from '@/screens/Credit/page/ui/CreditConditionsBlock/CreditConditions'
import CreditGetEasy from '@/screens/Credit/page/ui/CreditGetEasyBlock/CreditGetEasy'
import { CreditNotesBlock } from '@/screens/Credit/page/ui/CreditNotesBlock/CreditNotesBlock'
import { ExtraQuestions } from '@/screens/Credit/page/ui/ExtraQuestionsBlock/ExtraQuestions'

import CallMe from '@/screensComponents/FinancialServices/CallMe/CallMe'

import { HeroBannerInfo } from '@/widgets/HeroBannerInfo'

import { FaqSection } from '@/shared/ui/FaqSection'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'

import { faqItems, heroBannerInfoData } from './data'

import cl from './index.module.scss'

export const Credit = () => (
	<>
		<HeroBannerInfo {...heroBannerInfoData} onClick={() => {}} />
		<CreditGetEasy />
		<CreditConditions />
		<HorizontalSection title="Частые вопросы" borderNone>
			<FaqSection items={faqItems} />
		</HorizontalSection>
		<CreditNotesBlock />
		<ExtraQuestions />
		<CallMe body={'Вы можете получить консультацию по кредиту и рассрочке позвонив по номеру'} className={cl.mb} />
	</>
)
